import { initClipboardButton } from './src/clipboard-button.js';

// Initialize the button logic for the current page
document.addEventListener('DOMContentLoaded', () => {
	initClipboardButton();

	// handle alert notice close button clicks
	const uw_close_buttons = document.querySelectorAll(".uw-alert .close");
	[].forEach.call(uw_close_buttons, function(el) {
		el.addEventListener("click", function(e) {
			this.parentNode.parentNode.removeChild(this.parentNode);
			return false;
		});
	});
});
